import React from 'react';
import styles from './styles';
import PropTypes from 'prop-types';
import Image from 'next/image';

const FourColumnsCard = ({ block }) => {
  if (!block) return '';
  
  const { items } = block;

  return (
    <>
      <div className='main-container'>
        {items.map((item, i) => {
          return (
            <div className="card-container">
              <div className='card-image-container'>
                <Image draggable={false} 
                  src={item.icon.url}
                  alt={item.title1[0].text}
                  width={item.icon.dimensions.width}
                  height={item.icon.dimensions.height}
                  layout="intrinsic"
                  className="icon"
                />
              </div>

              <h3 className="title">{item.title1[0].text}</h3>
              <div className="description-container">
                <p className="description">{item.description[0].text}</p>
              </div>
              <span className="email-us">Email us:</span>
              <a className="email" href={`mailto:${item.email[0].text}`}>
                {item.email[0].text}
              </a>
              <a className="btn" href={`mailto:${item.email[0].text}`}>
                EMAIL US
              </a>
            </div>
          );})}
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
FourColumnsCard.propTypes = {
  block: PropTypes.shape({
    items: PropTypes.shape({
      description: PropTypes.array,
      email: PropTypes.array,
      icon: PropTypes.object,
      title1: PropTypes.array,
    }),
  }),
};

FourColumnsCard.defaultProps = {
  block: null,
};

export default FourColumnsCard;
